import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CgtTransactionHistory } from '../../Models/Domains/Transactions/Investments/CgtTransactionHistory';

declare var IS_RUNNING_IN_APP_POOL;

export class CgtTransactionHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(transId: number): Promise<Array<CgtTransactionHistory>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/CgtTransactionHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { transId: transId }

    return AjaxWrapper.get<Array<CgtTransactionHistory>, any>(url, data);
  }
}

